<template>
  <WorkflowStep v-if="!isLoadingAllFurniture" :step="step" :tab-data="scenarioTabs" />
</template>

<script>
import { useFurnitureStore } from '@/stores/furniture';
import scenarioTabs from '@/utils/tabs/scenario-tabs-enum';
import toolbarTab from '@/utils/tabs/toolbar-tabs-enum';
import { mapActions, mapState } from 'pinia';

export default {
  beforeRouteUpdate(to, from, next) {
    this.unloadData();

    next();
  },

  data() {
    return {
      step: toolbarTab.SPACE_TAB,
      scenarioTabs,
    };
  },

  computed: { ...mapState(useFurnitureStore, ['isLoadingAllFurniture']) },

  async created() {
    await this.fetchScenarioFurniture();
  },

  methods: { ...mapActions(useFurnitureStore, ['fetchScenarioFurniture', 'unloadData']) },
};
</script>

<style lang="scss"></style>
